import OWContainer from 'styles/styled-components/ow-container';
import { Spinner } from 'components/design';
import useController from '../controllers/edit-nested-product-controller';
import { NestedProductForm } from '../components/nested-product-form';

export const EditNestedProductRoute = () => {
    const {
        formData,
        onChange,
        onSubmit,
        onCancel,
        places,
        nestedProductCategories,
        dataChanged,
        isLoading,
        isEditProductLoading,
        errors,
        placeConfigData,
        isAdmin,
        isEdit,
        updateAll,
        setUpdateAll,
        onConfigPriceChange,
        placeId,
    } = useController();

    return (
        <OWContainer>
            {isLoading ? (
                <Spinner />
            ) : (
                <NestedProductForm
                    formData={formData}
                    places={places}
                    nestedProductCategories={nestedProductCategories}
                    onChange={onChange}
                    onSubmit={onSubmit}
                    onCancel={onCancel}
                    disableSubmit={!dataChanged}
                    isSaveLoading={isEditProductLoading}
                    errors={errors}
                    isAdmin={isAdmin}
                    isEdit={isEdit}
                    placeConfigData={placeConfigData}
                    updateAll={updateAll}
                    setUpdateAll={setUpdateAll}
                    onConfigPriceChange={onConfigPriceChange}
                    placeId={placeId}
                />
            )}
        </OWContainer>
    );
};
